import { useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../firebase/config";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

const AuthRedirect = () => {

const navigate = useNavigate();

useEffect(()=>{

const unsubscribe = onAuthStateChanged(auth, async (user)=>{

if(!user){
navigate("/login");
return;
}

try{

const userRef = doc(db,"usuarios",user.uid);

const userDoc = await getDoc(userRef);

if(!userDoc.exists()){
navigate("/login");
return;
}

let data = userDoc.data();

let rol = data.rol;
let subscriptionStatus = data.subscriptionStatus;
let planEnd = data.planEnd;

// ===============================
// VERIFICAR VENCIMIENTO DEL PLAN
// ===============================

if(planEnd){

let fechaFin;

if(planEnd.toDate){
fechaFin = planEnd.toDate();
}else{
fechaFin = new Date(planEnd);
}

const hoy = new Date();

if(hoy > fechaFin && subscriptionStatus === "active"){

await updateDoc(userRef,{
subscriptionStatus:"expired"
});

subscriptionStatus = "expired";

}

}

// ===============================
// ADMIN
// ===============================

if(rol === "admin"){
navigate("/admin",{replace:true});
return;
}

// ===============================
// USUARIOS
// ===============================

if(rol === "usuario"){

// PLAN ACTIVO
if(subscriptionStatus === "active"){
navigate("/home",{replace:true});
return;
}

// PAGO ENVIADO
if(subscriptionStatus === "payment_sent"){
navigate("/pago-pendiente",{replace:true});
return;
}

// PENDIENTE
if(subscriptionStatus === "pending"){
navigate("/pago-pendiente",{replace:true});
return;
}

// VENCIDO
if(subscriptionStatus === "expired"){
navigate("/planes",{replace:true});
return;
}

// SIN PLAN
navigate("/planes",{replace:true});
return;

}

}catch(error){

console.error("Error en AuthRedirect:",error);
navigate("/login");

}

});

return ()=>unsubscribe();

},[navigate]);

return null;

};

export default AuthRedirect;